/**
 * Copyright Motili Inc., 2016 All Rights Reserved
 */

// TODO: This component has not been updated to follow the 'common' component paradigm

import { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import FormLabel from 'common/components/form/FormLabel';

import * as Validator from '../../utils/Validator';

/**
 * FormEmailInput
 *
 * Standard Motili Email Input for use within a form
 *
 */
export default class FormEmailInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            validationState: null,
        };

        this.getValidationState = _getValidationState;
    }

    render() {
        const _label = this.props.noLabel ? null : (
            <FormLabel
                label={this.props.label || 'Email'}
                style={this.props.labelStyle}
            />
        );

        const isValid = this.state.validationState === 'success';
        const isInvalid = this.state.validationState === 'error';

        return (
            <Form.Group className='email-form' controlId='emailInput'>
                {_label}
                <FormControl
                    disabled={this.props.disabled}
                    type='email'
                    value={this.props.value}
                    placeholder='Email'
                    onChange={this.props.onChange}
                    onBlur={() =>
                        this.setState({
                            validationState: this.getValidationState(
                                this.props.value
                            ),
                        })
                    }
                    isValid={isValid}
                    isInvalid={isInvalid}
                    style={{
                        borderRadius: 0,
                    }}
                />
                {isInvalid && !this.props.noLabel && (
                    <Form.Control.Feedback type='invalid'>
                        Email is not valid
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        );
    }
}

FormEmailInput.propTypes = {
    noLabel: PropTypes.bool,
};

function _getValidationState(value) {
    if (Validator.isEmail(value)) {
        return 'success';
    }
    return 'error';
}
